import React from 'react'
import { Buttons } from "../../common/Buttons"
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LogoutIcon from '@mui/icons-material/Logout';
import imgIcon from '../../assets'
import { useNavigate } from 'react-router-dom';
import { isLogged } from '../../utils/common';
import { useDispatch } from 'react-redux';
import { signOutUser } from '../../actions/auth';
import config from '../../config';

export function Header({ showButton, path }) {

  const isLogin = isLogged();
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onClickHandler = (path) => {
    if (path === "/Done") {
      window.open(config?.webSite, "_self")
      // navigate("/")
      navigate(0)
    } else if (path === "/") {
      window.open(config?.webSite, "_self")
    }
    else {
      navigate(path)
    }
  }

  const handleOnClick = (link) => {
    window.open(config?.webSite, "_self")
  }

  const signOutHandler = () => {
    dispatch(signOutUser(navigate))
  }

  return (
    <>
      <div className="flex mt-4 pr-2 items-center text-lg justify-items-center" >
        {showButton &&
          <div> <Buttons onClick={() => onClickHandler(path)} btnText="Back" classN={"bg-transparent text-stardust flex w-auto text-sm"} Iconbefore={<ArrowBackIosNewIcon />} /> </div>
        }
        <div className="w-8/12 m-auto "><img onClick={() => { handleOnClick() }} className='w-36 ml-10 h-10 cursor-pointer' style={{ margin: "auto" }} src={imgIcon.logo} alt="" /></div>

        {isLogin && <div> <Buttons onClick={() => signOutHandler()} btnText="Sign Out" classN={"bg-transparent text-stardust flex w-auto text-sm hover:text-scogoOrange"} Iconbefore={<LogoutIcon />} /> </div> ||
          <div className="w-8" ></div>
        }

      </div>
    </>
  )
}
